module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp2_8004.a5de416e.png";